module.exports = __webpack_public_path__ + "img/shebei.34e3035c.png";